<div class="configurations-wrapper">
  <app-feature-list-container
    title="{{ '+INSTALLATIONS.INSTALLATION.ESS.CONFIGURATIONS.TITLE' | translate }}"
  >
    <div class="feature-grid-container" viFeatureGrid viBorderBottom>
      <!-- 1. Optimized self consumption toggle -->
      <app-feature-list-item
        *ngIf="essOptimalSelfConsumption$ | async as optimalSelfConsumption"
        [isNgContent]="true"
      >
        <div class="configuration-row">
          <span>{{
            '+INSTALLATIONS.INSTALLATION.ESS.CONFIGURATIONS.OPTIMIZED_SELF_CONSUMPTION' | translate
          }}</span>
          <mat-slide-toggle
            data-at-optimized-self-consumption-toggle
            gtm="onToggle"
            gtmAction="Switch optimized self consumption"
            gtmCategory="system"
            (click)="
              onToggleFeature(
                FEATURE_NAMES.essOptimalSelfConsumption,
                !optimalSelfConsumption.properties.active.value
              )
            "
            [checked]="optimalSelfConsumption.properties.active.value"
          >
          </mat-slide-toggle>
        </div>
      </app-feature-list-item>

      <!-- 2. Cyclic load compensation toggle -->
      <app-feature-list-item
        *ngIf="essCyclicLoadCompressor$ | async as cyclicLoadCompressor"
        class="configuration-row"
        [isNgContent]="true"
      >
        <div class="configuration-row">
          <span>{{
            '+INSTALLATIONS.INSTALLATION.ESS.CONFIGURATIONS.CYCLIC_LOAD_COMPENSATION' | translate
          }}</span>
          <mat-slide-toggle
            data-at-cyclic-load-compensation-toggle
            gtm="onToggle"
            gtmAction="Switch cyclic load compensation"
            gtmCategory="system"
            (click)="
              onToggleFeature(
                FEATURE_NAMES.essCyclicLoadCompressor,
                !cyclicLoadCompressor.properties.active.value
              )
            "
            [checked]="cyclicLoadCompressor.properties.active.value"
          >
          </mat-slide-toggle>
        </div>
      </app-feature-list-item>

      <!-- 3. SoC based battery sleep mode toggle -->
      <app-feature-list-item
        *ngIf="essBatterySleepMode$ | async as batterySleepMode"
        [isNgContent]="true"
      >
        <div class="configuration-row">
          <span>{{
            '+INSTALLATIONS.INSTALLATION.ESS.CONFIGURATIONS.SOC_BASED_BATTERY_SLEEP_MODE'
              | translate
          }}</span>
          <mat-slide-toggle
            data-at-soc-based-battery-sleep-mode-toggle
            gtm="onToggle"
            gtmAction="Switch SoC based battery sleep mode"
            gtmCategory="system"
            (click)="
              onToggleFeature(
                FEATURE_NAMES.essBatterySleepMode,
                !batterySleepMode.properties.active.value
              )
            "
            [checked]="batterySleepMode.properties.active.value"
          >
          </mat-slide-toggle>
        </div>
      </app-feature-list-item>

      <!-- 4. Backup reserve capacity toggle -->
      <app-feature-list-item
        *ngIf="essBackupReservedCapacity$ | async as backupReservedCapacity"
        [isNgContent]="true"
      >
        <div class="configuration-row">
          <span>{{
            '+INSTALLATIONS.INSTALLATION.ESS.CONFIGURATIONS.SOC_BACKUP_RESERVE_CAPACITY' | translate
          }}</span>
          <mat-slide-toggle
            data-at-backup-reserve-capacity-toggle
            gtm="onToggle"
            gtmAction="Switch backup reserve capacity"
            gtmCategory="system"
            (click)="
              onToggleFeature(
                FEATURE_NAMES.essBackupReservedCapacity,
                !backupReservedCapacity.properties.active.value
              )
            "
            [checked]="backupReservedCapacity.properties.active.value"
          >
          </mat-slide-toggle>
        </div>
      </app-feature-list-item>
    </div>
  </app-feature-list-container>
</div>
